export const apiUrl = "https://api.personalizedpatchesforhats.com"
export const brands = "BlankBeanies";